import Vue from 'vue';
import Router from 'vue-router';

import login from '@/components/login';
import layout from '@/components/layout';
import exceldetail from '@/components/exceldetail';
import paydetail from '@/components/paydetail';
import payimport from '@/components/payimport';
import payexcels from '@/components/payexcels';
import basicinfo from '@/components/basicinfo';
import pwdmodify from '@/components/pwdmodify';
import recharges from '@/components/recharges';
import addaccount from '@/components/addaccount';
import addprovider from '@/components/addprovider';
import addrecharge from '@/components/addrecharge';
import rechargeverify from '@/components/rechargeverify';
import auditrecharge from '@/components/auditrecharge';
import moneyview from '@/components/moneyview';
import limituser from '@/components/limituser';
import accounts from '@/components/accounts';
import usermanage from '@/components/usermanage';
import userdetail from '@/components/userdetail';

import enterpList from '@/pages/contractManage/enterpList';
import personList from '@/pages/contractManage/personList';
import personProof from '@/pages/dutyPaid/personProof';
import providerProof from '@/pages/dutyPaid/providerProof';
import invoiceApply from '@/pages/invoice/invoiceApply';
import invoiceManage from '@/pages/invoice/invoiceManage';
import invoiceRest from '@/pages/invoice/invoiceRest';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'login',
    component: login,
  },
  {
    path: '/layout',
    component: layout,
    children: [
      {
        path: '/exceldetail',
        component: exceldetail,
      },
      {
        path: '/paydetail',
        component: paydetail,
      },
      {
        path: '/payimport',
        component: payimport,
      },
      {
        path: '/payexcels',
        component: payexcels,
      },
      {
        path: '/basicinfo',
        component: basicinfo,
      },
      {
        path: '/pwdmodify',
        component: pwdmodify,
      },
      {
        path: '/recharges',
        component: recharges,
      },
      {
        path: '/addaccount',
        component: addaccount,
      },
      {
        path: '/addprovider',
        component: addprovider,
      },
      {
        path: '/addrecharge',
        component: addrecharge,
      },
      {
        path: '/rechargeverify',
        component: rechargeverify,
      },
      {
        path: '/auditrecharge',
        component: auditrecharge,
      },
      {
        path: '/moneyview',
        component: moneyview,
      },
      {
        path: '/limituser',
        component: limituser,
      },
      {
        path: '/accounts',
        component: accounts,
      },
      {
        path: '/enterpList',
        component: enterpList,
      },
      {
        path: '/personList',
        component: personList,
      },
      {
        path: '/personProof',
        component: personProof,
      },
      {
        path: '/providerProof',
        component: providerProof,
      },
      {
        path: '/invoiceApply',
        component: invoiceApply,
      },
      {
        path: '/invoiceManage',
        component: invoiceManage,
      },
      {
        path: '/invoiceRest',
        component: invoiceRest,
      },
      {
        path: '/usermanage',
        component: usermanage,
      },
      {
        path: '/userdetail',
        component: userdetail,
      },
    ],
  },
];

export default new Router({
  routes,
});



// WEBPACK FOOTER //
// ./src/router/index.js